import { Box } from "@mui/material";
import React from "react";

const COMPANY_NAME = "株式会社LOGEX";
const APP_NAME = "ラクロジ";
const SUPPORT_EMAIL = "support@logex.jp";
const ADDRESS = "神奈川県川崎市川崎区中島1-2-9-302";
const LAST_UPDATED = "2025-10-22";

const Privacy: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100vw", // 全画面幅
        height: "100vh", // 全画面高さ
        overflow: "auto", // 外側でスクロールを制御
        paddingLeft: "10px",
      }}
    >
      <main className="mx-auto max-w-3xl px-5 py-10 leading-7 text-gray-900">
        <header className="mb-8">
          <h1 className="text-3xl font-bold">プライバシーポリシー</h1>
          <p className="mt-2 text-sm text-gray-600">
            最終更新日：{LAST_UPDATED}
          </p>
        </header>

        <section className="space-y-6">
          <p>
            本プライバシーポリシーは、{COMPANY_NAME}
            （以下「当社」）が提供するアプリケーション「{APP_NAME}
            」（以下「本アプリ」）における、ユーザーの個人情報および販売パートナーデータの取扱いについて定めるものです。
          </p>

          <section>
            <h2 className="mb-2 text-xl font-semibold">1. 収集する情報</h2>
            <p>
              本アプリは、Amazon Selling Partner
              API（SP-API）を通じて、以下の情報を取得する場合があります。
            </p>
            <ul className="list-disc pl-6">
              <li>出品情報（商品名、SKU、価格など）</li>
              <li>注文情報（注文番号、購入者氏名は含まない）</li>
              <li>納品および在庫データ</li>
              <li>販売実績データ</li>
            </ul>
            <p className="mt-2">
              これらの情報は、ユーザーの同意に基づき、OAuth認可フローを通じて取得されます。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">2. 利用目的</h2>
            <p>当社は取得した情報を以下の目的で利用します。</p>
            <ul className="list-disc pl-6">
              <li>在庫管理・出荷処理の自動化</li>
              <li>売上分析およびレポートの提供</li>
              <li>システム改善およびエラー解析</li>
            </ul>
            <p className="mt-2">上記以外の目的では利用しません。</p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">3. 第三者提供</h2>
            <p>
              当社は、ユーザーの販売パートナーデータを第三者に提供しません。ただし、法令に基づく要請がある場合、またはAmazonの利用規約に基づく対応が必要な場合を除きます。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">4. セキュリティ</h2>
            <p>
              データの送受信はHTTPS等の暗号化通信を用いて行います。アクセス権限は最小限に限定し、適切な管理を行います。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">
              5. データの保持・削除
            </h2>
            <p>
              本アプリは取得したデータを最大90日間保持し、その後自動的に削除します。ユーザーがOAuth認可を解除した場合、当社は保有データを速やかに削除します。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">6. ユーザーの権利</h2>
            <p>
              ユーザーは、当社に対し自身のデータの開示、訂正、削除を求めることができます。お問い合わせ先は下記をご参照ください。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">7. 本ポリシーの変更</h2>
            <p>
              当社は必要に応じて本ポリシーを変更することがあります。変更後の内容は当社ウェブサイトに掲示した時点から効力を生じます。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">8. お問い合わせ</h2>
            <address className="not-italic">
              {COMPANY_NAME}
              <br />
              メール：
              <a
                className="text-blue-700 underline"
                href={`mailto:${SUPPORT_EMAIL}`}
              >
                {SUPPORT_EMAIL}
              </a>
              <br />
              住所：{ADDRESS}
            </address>
          </section>
        </section>
      </main>
    </Box>
  );
};

export default Privacy;
